export default "__VITE_ASSET__tvaImfF3__"